import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail, Phone, Shield, Users, FileText } from "lucide-react";
import { Footer } from "@/components/layout/Footer";

export const Contact = () => {
  const contacts = [
    {
      id: "general",
      title: "General Inquiries",
      icon: Mail,
      value: "contact@snaplading.com",
      href: "mailto:contact@snaplading.com",
      description: "Questions about SnapLading and partnership opportunities.",
    },
    {
      id: "support",
      title: "Product Support",
      icon: Mail,
      value: "support@snaplading.com",
      href: "mailto:support@snaplading.com",
      description: "Help with uploads, processing, and troubleshooting.",
    },
    {
      id: "careers",
      title: "Careers",
      icon: Users,
      value: "careers@snaplading.com",
      href: "mailto:careers@snaplading.com",
      description: "Applications and questions about open positions.",
    },
    {
      id: "privacy",
      title: "Privacy",
      icon: Shield,
      value: "privacy@snaplading.com",
      href: "mailto:privacy@snaplading.com",
      description: "Data protection, privacy rights, and deletion requests.",
    },
    {
      id: "legal",
      title: "Legal",
      icon: FileText,
      value: "legal@snaplading.com",
      href: "mailto:legal@snaplading.com",
      description: "Terms, licensing, and contractual matters.",
    },
    {
      id: "phone",
      title: "Phone",
      icon: Phone,
      value: "(647) 250-1215",
      href: "tel:+16472501215",
      description:
        "Direct line for urgent inquiries during business hours.  Business hours: 9 AM – 5 PM EST.",
    },
  ];

  return (
    <div className="min-h-screen text-white landing-dark">
      <nav className="fixed top-0 w-full z-50 bg-gray-900/80 backdrop-blur-lg border-b border-gray-700">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold gradient-text-purple">
                SnapLading
              </a>
            </div>
            <div className="flex items-center gap-4">
              <Button size="sm" className="button-purple button-modern" asChild>
                <a href="/app/upload">Dashboard</a>
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <section className="pt-32 pb-20 px-4 lg:px-8 relative bg-black">
        <div className="container mx-auto max-w-7xl">
          <div className="text-center space-y-8">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight">
              <span className="text-white">Get in </span>
              <span className="gradient-text-purple">Touch</span>
            </h1>
            <p className="text-xl sm:text-2xl text-gray-300 max-w-3xl mx-auto">
              Reach the right team at SnapLading.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 lg:px-8 gradient-bg-purple-grey">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {contacts.map((c) => {
              const Icon = c.icon;
              return (
                <Card key={c.id} className="bg-gray-900 border-gray-800">
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-purple-600/20 rounded-lg flex items-center justify-center">
                        <Icon className="w-6 h-6 text-purple-400" />
                      </div>
                      <div>
                        <CardTitle className="text-2xl text-white">
                          {c.title}
                        </CardTitle>
                        <CardDescription className="text-base text-gray-400">
                          {c.description}
                        </CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <a
                      href={c.href}
                      className="text-purple-400 hover:text-purple-300 break-words"
                    >
                      {c.value}
                    </a>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
